export class Campaign {
  public static types = {
    0: 'Standard Video',
    1: 'Responsive Video',
    2: 'Search Campaign'
  }
}
